import React from 'react';
import { createPortal } from 'react-dom';
import { ModalContainer, ModalBackdrop, ModalHeader, ModalContent, ModalClose } from './styled.js';

const modalRoot = document.getElementById('modalContainer');

class RoundedModal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    modalRoot && modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot && modalRoot.removeChild(this.el);
  }

  render() {
    const { children, isOpen, title, close, fullWidth = false } = this.props;

    const modal = isOpen ?
      (<ModalContainer isOpen={isOpen}>
        <ModalBackdrop onClick={() => close()} />
        <ModalContent fullWidth={fullWidth}>
          <ModalHeader>{title || ''}</ModalHeader>
          <ModalClose onClick={() => close()}>×</ModalClose>
          {children}
        </ModalContent>
      </ModalContainer>) : null;

    return createPortal(
      modal,
      this.el,
    );
  }
}

export default RoundedModal;
